module.exports = __webpack_public_path__ + "static/media/iiitk_logo.992a2e8b.png";